var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"people4"},[_c('h4',[_vm._v("2018年10月12日 "),_c('el-tag',{attrs:{"size":"medium","type":"success"}},[_vm._v("感冒")])],1),_vm._v(" "),_c('h5',[_vm._v("手术方式治疗")]),_vm._v(" "),_c('p',[_vm._v("颈椎病的治疗方式分为手术...")]),_vm._v(" "),_c('div',{staticClass:"drug_p"},[_c('drug'),_vm._v(" "),_c('drug3')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-38beaa72","hasScoped":true,"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/people4.vue
// module id = 232
// module chunks = 1